<script>
  import { onMount, getContext } from 'svelte';
  import { fade, fly } from 'svelte/transition';

  import { CATEGORIES } from '../../graphql/events';

  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';

  export let label;
  export let value;
  export let readonly = false;

  let query = client.watchQuery({ query: CATEGORIES });
  let results = { loading: true };

  function setResponse({ data, loading, error, networkStatus }) {
    results = {
      loading,
      categories: data && data.eventCategories ? data.eventCategories : []
    };
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({ error, loading: false });
    }
  });
</script>

<div>
  <!-- LABEL -->
  {#if label}<label>{label}</label>{/if}
  <!-- LOADER -->
  {#if results.loading}
  <Loader></Loader>
  {/if}
  <!-- COMPONENT -->
  {#if !results.loading}
  <select
    class:placeholder="{!value}"
    disabled="{readonly}"
    readonly="{readonly}"
    bind:value
  >
    <option value="{null}">Choose a Category</option>
    {#each results.categories as category, i}
    <option value="{category.id}">
      {category.name}
    </option>
    {/each}
  </select>
  {/if}
</div>
